var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 12.7308C10.8366 12.7308 12.7308 10.8366 12.7308 8.49999C12.7308 6.1634 10.8366 4.26922 8.5 4.26922C6.16341 4.26922 4.26923 6.1634 4.26923 8.49999C4.26923 10.8366 6.16341 12.7308 8.5 12.7308ZM8.5 13.5C11.2614 13.5 13.5 11.2614 13.5 8.49999C13.5 5.73857 11.2614 3.49999 8.5 3.49999C5.73858 3.49999 3.5 5.73857 3.5 8.49999C3.5 11.2614 5.73858 13.5 8.5 13.5ZM5.5 8.49999C5.5 8.29289 5.66789 8.12499 5.875 8.12499H8.125V5.87499C8.125 5.66789 8.29289 5.49999 8.5 5.49999C8.70711 5.49999 8.875 5.66789 8.875 5.87499V8.12499H11.125C11.3321 8.12499 11.5 8.29289 11.5 8.49999C11.5 8.7071 11.3321 8.87499 11.125 8.87499H8.875V11.125C8.875 11.3321 8.70711 11.5 8.5 11.5C8.29289 11.5 8.125 11.3321 8.125 11.125V8.87499H5.875C5.66789 8.87499 5.5 8.7071 5.5 8.49999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelAdd);
export default __webpack_public_path__ + "static/media/model-add.4ebd3304d795e1201ab5abfee848e968.svg";
export { ForwardRef as ReactComponent };